import { ZoomIn, ZoomOut } from '@mui/icons-material';
import { CircularProgress, LinearProgress } from '@mui/material';
import React,{useState,useEffect} from 'react'

function AvtarSpeach({speachMessage,setSpeachMessage,voiceIndex,sendSpeechRecognitionMessage}) {

    const [isSpeaking,setIsspeaking] = useState(false);
    const [isListning,setIsListning] = useState(false);

    const [audioMsg,setAudioMsg] = useState(false);

    const [avtarZoom,setAvatarZomm] = useState(false);

    const speak = () => {
        
        console.log(speachMessage);
        let text = "";

        if(speachMessage.messageType == "text"){
            text = speachMessage.formValues.messageBody;
            let delimiter = /((?:https?:\/\/)?(?:(?:[a-z0-9]?(?:[a-z0-9\-]{1,61}[a-z0-9])?\.[^\.|\s])+[a-z\.]*[a-z]+|(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3})(?::\d{1,5})*[a-z0-9.,_\/~#&=;%+?\-\\(\\)]*)/gi;
            text = text.replace(delimiter, "")
        }

        if(speachMessage.messageType === "interactiveReply" || speachMessage.messageType === "interactiveList"){
            text = speachMessage.formValues.headerText === undefined ? "" :speachMessage.formValues.headerText;
            text = text+" "+speachMessage.formValues.bodyText;
        }
        
        if(voiceIndex !== null){
            var utterance = new SpeechSynthesisUtterance();
            utterance.text = text;
            utterance.voice = speechSynthesis.getVoices()[voiceIndex];
            
            let synth = speechSynthesis;
            
            synth.speak(utterance);

            let myInterval = setInterval(()=>{
                if(synth.speaking){
                    setIsspeaking(true);
                    console.log("speaking")
                } else{
                    setIsspeaking(false);
                    console.log("stop speaking")
                    clearInterval(myInterval);
                }
            }, 500);

        }
        
        
    }

    useEffect(()=>{
        speak();
    },[speachMessage]);


    const listen = () =>{
        let SR = window.SpeechRecognition || window.webkitSpeechRecognition;
        let r = new SR();
        //console.log(r);
        r.start();
        r.onstart = (e) =>{
            setAudioMsg("");
            //setDialogStatus(true);
            setIsListning(true);
            
            //console.log("Started")
        }
        r.onend = (e) =>{
            //setDialogStatus(false);
            //console.log("ended")
            setIsListning(false);
        }
        r.onresult = (e) =>{
            console.log(e);
            console.log(e.results[0][0].transcript)
            sendSpeechRecognitionMessage(e.results[0][0].transcript)
            setAudioMsg(e.results[0][0].transcript)
            //sendMessage(e.results[0][0].transcript)
            //setListenValue(e.results[0][0].transcript);
        }
        
    }

    return (
        <div className='card mt-5'>
            <div className='card-body'>
                
                
                {!avtarZoom && 
                    <>
                        <button className='btn btn-outline-primary float-end' onClick={()=>setAvatarZomm(true)} ><ZoomIn/></button>
                        {isSpeaking ? 
                            <img src='/images/chatbot/model/natural-lori.gif' className='img-thumbnail' />
                            :
                            <img src='/images/chatbot/model/silent-lori.gif' className='img-thumbnail' />
                        }
                    </>
                }

                {avtarZoom && 
                    <>
                        <button className='btn btn-outline-primary float-end' onClick={()=>setAvatarZomm(false)} ><ZoomOut/></button>
                        {isSpeaking? 
                            <div style={{backgroundImage: "url(/images/chatbot/model/natural-lori.gif)", width:"100%", height:500, backgroundPositionX:"center" }}></div>
                            :
                            <div style={{backgroundImage: "url(/images/chatbot/model/silent-lori.gif)", width:"100%", height:500, backgroundPositionX:"center" }}></div>
                        }
                    </>
                }


                {/*<img src='/images/chatbot/model/status-0-lori.gif' className='img-thumbnail' /> */}
                {/* <img src='/images/chatbot/model/natural-lori.gif' className='img-thumbnail' /> */}
            </div>
            <div className='card-body'>
                
                    {isListning && 
                        <div className='row'>
                            <div className='col-md-12'>
                                <LinearProgress/>
                            </div>
                        </div>
                    }
                    {!isListning && 
                        <div className='row'>
                            <button className='btn btn-outline-primary' onClick={listen} >Touch To Speak</button>
                        </div>
                    }
            </div>
        </div>
    )
}

export default AvtarSpeach